"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const String_1 = require("@pups/utility/build/String");
class Model {
    /**
     *
     *
     * @returns {Object}
     * @memberof Model
     */
    export() {
        const data = {};
        this.exportableProperties.forEach(p => { data[p] = this['get' + String_1.ucfirst(p)](true); });
        return data;
    }
}
exports.default = Model;
//# sourceMappingURL=Model.js.map